import React from "react";

export const CartIcon = () => (
  <svg
    width="32"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <path
        d="M13.439 14.1172H36.5611C38.3657 14.1172 39.9468 15.3135 40.4207 17.0375L47.9712 44.5045C48.6636 47.0234 46.7482 49.505 44.1116 49.505H5.88847C3.25185 49.505 1.33646 47.0234 2.02889 44.5045L9.57937 17.0375C10.0533 15.3136 11.6344 14.1172 13.439 14.1172Z"
        stroke="#0094FF"
        strokeWidth="2"
      />
      <path
        d="M35.5 21.8021C35.5 22.1256 35.2535 22.3464 35 22.3464C34.7465 22.3464 34.5 22.1256 34.5 21.8021C34.5 21.4785 34.7465 21.2577 35 21.2577C35.2535 21.2577 35.5 21.4785 35.5 21.8021Z"
        stroke="#0094FF"
        strokeWidth="2"
      />
      <path
        d="M15.5 21.8021C15.5 22.1256 15.2535 22.3464 15 22.3464C14.7465 22.3464 14.5 22.1256 14.5 21.8021C14.5 21.4785 14.7465 21.2577 15 21.2577C15.2535 21.2577 15.5 21.4785 15.5 21.8021Z"
        stroke="#0094FF"
        strokeWidth="2"
      />
      <path
        d="M15 22.2824C18.3333 -4.85539 31.6667 -6.00673 35 22.2824"
        stroke="#0094FF"
        strokeWidth="2"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="50" height="50" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
